import { render, staticRenderFns } from "./classUseTime.vue?vue&type=template&id=6af10cb1&scoped=true&"
import script from "./classUseTime.vue?vue&type=script&lang=ts&"
export * from "./classUseTime.vue?vue&type=script&lang=ts&"
import style0 from "./classUseTime.vue?vue&type=style&index=0&id=6af10cb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af10cb1",
  null
  
)

export default component.exports